import styles from "../../../styles.module.scss";

interface TimeCellProps {
  value: number;
}

export const TimeCell = ({ value }: TimeCellProps) => {
  const msToDays = (seconds: number) => {
    const days = seconds / (86400 * 1000); // 86400 seconds in a day
    return parseFloat(days.toFixed(1)); // Round to 1 decimal place
  };

  return <div className={styles.timeSaving}>{msToDays(value)} d</div>;
};
